/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/
import request from 'request';
import store from './store.js';
import actions from './actions';
import {gotoView} from './actions/view';

let config = require('../settings/config.json');

const p = console.log


const publicationList = (callback)=>{
    request(window.location.origin + config.server[window.env].apiUrl + 'publications' , function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
      callback(res)
    }else{
      callback([])
    }
  })
}

const refreshBilling = function (callback) {
  // console.log(window.location.origin + config.server[window.env].apiUrl + 'cards')
   request(window.location.origin + config.server[window.env].apiUrl + 'cards' , function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
      callback(res)
    }else{
      // console.log(error)
      callback(null)
    }
  })
}

const removeCard = function (id, callback) {
  // console.log(window.location.origin + config.server[window.env].apiUrl + 'removecard?id='+id)
   request(window.location.origin + config.server[window.env].apiUrl + 'removecard?id='+id , function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
      // console.log(res)
      callback(res)
    }else{
      console.log("REMOVE CARD FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const addIban = function (callback) {
  // console.log(window.location.origin + config.server[window.env].apiUrl + 'addcard')
   request(window.location.origin + config.server[window.env].apiUrl + 'addiban' , function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
      callback(res)
    }else{
      // console.log("GEO LOCATION FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const addCard = function (callback) {
  // console.log(window.location.origin + config.server[window.env].apiUrl + 'addcard')
   request(window.location.origin + config.server[window.env].apiUrl + 'addcard' , function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
      callback(res)
    }else{
      // console.log("GEO LOCATION FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const fetchFeed = function (feed, offset, menu) {
  const { fetchFeed } = actions; //updateMenu
  // if(menu && (JSON.stringify(menu) !== JSON.stringify(feed.menu))){
  //   console.log('MENU CHANGED: WILL UPDATE MENU')
  //   feed.menu = menu
  //   store.dispatch(updateMenu(feed, menu))
  // }
  //TODO: the following line should be removed and the check should be done earlier
  if(feed.id==='map' || feed.id == "search") return search(feed.lastRequest.query, offset, feed)

  store.dispatch(fetchFeed(feed, offset))
}

const search = function(query, offset, feed){
  if(query || feed.product==='landingpage' || (feed.menu && feed.menu.find(m=>m.value==='orders' && m.selected))){
    const {search} = actions;
    store.dispatch(search(query, offset, feed))
  }
}

const geoLocation = function (callback){

  request(location.protocol + '//ip-api.com/json', function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
       let res = {lat:res.lat,
                  long:res.lon,
                  zoom:10,
                  country_name:res.country,
                  country:res.countryCode.toLowerCase(),
                  city:res.city}

      callback(res)
    }else{
      // console.log("GEO LOCATION FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const geoLocation2 = function (callback){
  // request(location.protocol + '//api.ipstack.com/31.15.50.74?access_key=1cdd371ebf542906fa2047034f4774de', function (error, response, body) {
  request(location.protocol + '//gd.geobytes.com/GetCityDetails', function (error, response, body) {
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
       let res = {lat:res.geobyteslatitude, 
                  long:res.geobyteslongitude, 
                  zoom:10, 
                  country_name:res.geobytescountry, 
                  country:res.geobytesinternet.toLowerCase(), 
                  city:res.geobytesregion}
        callback(res)
    }else{
      // console.log("GEO LOCATION FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const geoLocation1 = function (callback){
  // request(location.protocol + '//api.ipstack.com/31.15.50.74?access_key=1cdd371ebf542906fa2047034f4774de', function (error, response, body) {
  request('http://www.geoplugin.net/json.gp', function (error, response, body) {
    console.log(body)
    console.log(response)
    if (!error && response.statusCode == 200) {
      var res = JSON.parse(body)
       let res = {lat:res.geobyteslatitude, 
                  long:res.geobyteslongitude, 
                  zoom:10, 
                  country_name:res.geobytescountry, 
                  country:res.geobytesinternet.toLowerCase(), 
                  city:res.geobytesregion}
        callback(res)
    }else{
      // console.log("GEO LOCATION FAILED")
      // console.log(error)
      callback(null)
    }
  })
}

const get = function (path, callback){
  request(window.location.origin + config.server[window.env].apiUrl + path, function (error, response, body) {
    if(!error && response.statusCode == 200){
      var res = JSON.parse(body)
      res = res && res.feed  && res.feed[0] ? res.feed[0] : (res[0] ? res[0] : res)
      var cRes = {response:response, body:res}
      if(callback){
        callback(error,cRes)
      }
    }
 
  })
}

const post = (path, body)=>{
 
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    };

    let url = config.server[window.env].url+config.server[window.env].apiUrl.slice(1)+path
    
    return fetch(url, requestOptions).then(response => response.json())

}

export {fetchFeed, get, post, search, geoLocation, refreshBilling, addCard, addIban, removeCard, publicationList}